<template>
  <div
    class="divider_container"
    :class="[
      direction === 'vertical' ? 'd-flex-col' : 'd-flex-row',
      !showOr && 'no_show_or',
      direction,
    ]"
  >
    <div class="left_div"></div>
    <h5 class="caps medium-s t-white font-family-2" v-if="showOr">
      {{ text }}
    </h5>
    <div class="right_div"></div>
  </div>
</template>

<script>
export default {
  props: {
    showOr: {
      type: Boolean,
      default: true,
    },
    text: {
      default: "OR",
    },
    direction: {
      type: String,
      default: "horizontal", // or "vertical"
      validator: (val) => ["horizontal", "vertical"].includes(val),
    },
  },
};
</script>
